import { render, staticRenderFns } from "./BChip.vue?vue&type=template&id=c9b1b3dc&scoped=true"
import script from "./BChip.vue?vue&type=script&setup=true&lang=ts"
export * from "./BChip.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BChip.vue?vue&type=style&index=0&id=c9b1b3dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b1b3dc",
  null
  
)

export default component.exports